import { createStyles, Theme } from '@material-ui/core/styles';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { NotificationMessageProps } from '@/components/output/NotificationMessage/types';
import { makeSelectIsMobileView } from '@/model/global/selectors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alert: {
      margin: theme.spacing(4),
      marginTop: 0,
    },
    alertMobile: {},
  }),
);

const Alert: React.FC<AlertProps> = (props: AlertProps) => <MuiAlert elevation={6} variant="filled" {...props} />;

const selectIsMobile = makeSelectIsMobileView();

const NotificationMessage: React.FC<NotificationMessageProps> = ({
  title,
  className,
  children,
  severity = 'error',
  'data-test': dataTest,
  ...props
}) => {
  const classes = useStyles();
  const isMobile = useSelector(selectIsMobile);
  return (
    <Alert
      severity={severity}
      className={clsx(className, isMobile ? classes.alertMobile : classes.alert)}
      data-test={dataTest}
      {...props}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </Alert>
  );
};

export default NotificationMessage;
